import Icon from "./icon";
export { default as createFromIconfontCN } from "./icon-font";
export { test05Url, stageUrl, prdUrl } from "./const";
export default Icon;